import API from 'src/util/api'
import Config from 'src/util/config'

export function fetchDropdowns() {
  return API.get(`dropdown?type=courses,units,chapters,lessons`)
}

export function fetchVideoCategoryDropdowns() {
  return API.get(`videoCategoryDropdown`)
}

export function fetchProducts() {
  return API.get(`products`)
}

export function fetchRzpPlans() {
  return API.get(`rzp-plans`)
}

export function fetchLoggedInUserInfo() {
  return API.get(`me`)
}

export function fetchBanners() {
  return API.get(`banners`)
}

export function fetchLessons({ queryKey }) {
  const [_key, { pageIndex, pageSize }] = queryKey
  return API.get(`lessons?pageSize=${pageSize}&page=${pageIndex + 1}`)
}

export function fetchTranslationTransliteration({ text, sourceLang, targetLang }) {
  return API.get(`wordVocabulary/${text}?sourceLanguage=${sourceLang}&targetLanguage=${targetLang}`);
}

export function fetchFourLData(payload) {
  return API.post(Config.API_URI + 'fourl-data', payload);
}

export function addUpdateBanner(data) {
  return API.post(`banner`, data)
}

export function fetchVideos({ searchText, additionalFilters }) {
  return API.get(`videos?searchText=${searchText}${additionalFilters
    ? `&appliedCustomFilter=true&${toQueryString(additionalFilters)}`
    : ''
    }`)
}

export function createListFetcher(apiName) {
  return function fetchList({ queryKey }) {
    const [_key, { pageIndex, pageSize, searchText, additionalFilters, _id }] =
      queryKey

    return API.get(
      `${apiName}?pageSize=${pageSize}&page=${pageIndex + 1}${searchText ? `&searchText=${searchText}` : ''
      }${additionalFilters
        ? `&appliedCustomFilter=true&${toQueryString(additionalFilters)}`
        : ''
      }${_id ? `&_id=${_id}` : ""}`
    )
  }
}

// Fetch every record of a paginated list endpoint (used by the table CSV export)
export async function fetchAllListRows(apiName) {
  const pageSize = 500
  const allRows = []
  let page = 1
  let totalPages = 1

  do {
    const data = await API.get(`${apiName}?pageSize=${pageSize}&page=${page}`)
    const docs = data?.docs || (Array.isArray(data) ? data : [])
    allRows.push(...docs)
    totalPages = data?.totalPages ?? 1
    page++
  } while (page <= totalPages)

  return allRows
}

// object to query string
export function toQueryString(obj) {
  return Object.keys(obj)
    .filter(
      key => obj[key] !== undefined && obj[key] !== null && obj[key] !== ''
    )
    .map(key => `${key}=${obj[key]}`)
    .join('&')
}
